/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as SettingsRouteRouteImport } from './routes/settings.route'
import { Route as ProspectsRouteRouteImport } from './routes/prospects.route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as ProspectsIndexRouteImport } from './routes/prospects.index'
import { Route as NotAuthorizedSplatRouteImport } from './routes/notAuthorized/$'
import { Route as ProspectsProspectIdRouteRouteImport } from './routes/prospects/$prospectId.route'
import { Route as ProspectsProspectIdIndexRouteImport } from './routes/prospects/$prospectId.index'
import { Route as ProspectsProspectIdLivingStoryRouteImport } from './routes/prospects/$prospectId/living-story'
import { Route as SettingsCommunityCommunityIdRouteRouteImport } from './routes/settings/community/$communityId.route'
import { Route as ProspectsProspectIdRecordingsRouteRouteImport } from './routes/prospects/$prospectId/recordings.route'
import { Route as ProspectsProspectIdDocumentsRouteRouteImport } from './routes/prospects/$prospectId/documents.route'
import { Route as SettingsCommunityCommunityIdIndexRouteImport } from './routes/settings/community/$communityId.index'
import { Route as ProspectsProspectIdRecordingsIndexRouteImport } from './routes/prospects/$prospectId/recordings.index'
import { Route as ProspectsProspectIdDocumentsIndexRouteImport } from './routes/prospects/$prospectId/documents.index'
import { Route as SettingsCommunityCommunityIdUsersRouteImport } from './routes/settings/community/$communityId/users'
import { Route as SettingsCommunityCommunityIdRolesRouteImport } from './routes/settings/community/$communityId/roles'
import { Route as SettingsCommunityCommunityIdPermissionsRouteImport } from './routes/settings/community/$communityId/permissions'
import { Route as ProspectsProspectIdDocumentsNewRouteImport } from './routes/prospects/$prospectId/documents/new'
import { Route as ProspectsProspectIdRecordingsRecordingIdRouteRouteImport } from './routes/prospects/$prospectId/recordings/$recordingId.route'
import { Route as ProspectsProspectIdRecordingsRecordingIdIndexRouteImport } from './routes/prospects/$prospectId/recordings/$recordingId.index'
import { Route as ProspectsProspectIdDocumentsDocumentIdIndexRouteImport } from './routes/prospects/$prospectId/documents/$documentId.index'
import { Route as ProspectsProspectIdRecordingsRecordingIdTranscriptRouteImport } from './routes/prospects/$prospectId/recordings/$recordingId/transcript'
import { Route as ProspectsProspectIdRecordingsRecordingIdSummaryRouteImport } from './routes/prospects/$prospectId/recordings/$recordingId/summary'
import { Route as ProspectsProspectIdDocumentsDocumentIdEditRouteImport } from './routes/prospects/$prospectId/documents/$documentId.edit'

const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProspectsRouteRoute = ProspectsRouteRouteImport.update({
  id: '/prospects',
  path: '/prospects',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const ProspectsIndexRoute = ProspectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProspectsRouteRoute,
} as any)
const NotAuthorizedSplatRoute = NotAuthorizedSplatRouteImport.update({
  id: '/notAuthorized/$',
  path: '/notAuthorized/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProspectsProspectIdRouteRoute =
  ProspectsProspectIdRouteRouteImport.update({
    id: '/$prospectId',
    path: '/$prospectId',
    getParentRoute: () => ProspectsRouteRoute,
  } as any)
const ProspectsProspectIdIndexRoute =
  ProspectsProspectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProspectsProspectIdRouteRoute,
  } as any)
const ProspectsProspectIdLivingStoryRoute =
  ProspectsProspectIdLivingStoryRouteImport.update({
    id: '/living-story',
    path: '/living-story',
    getParentRoute: () => ProspectsProspectIdRouteRoute,
  } as any)
const SettingsCommunityCommunityIdRouteRoute =
  SettingsCommunityCommunityIdRouteRouteImport.update({
    id: '/community/$communityId',
    path: '/community/$communityId',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const ProspectsProspectIdRecordingsRouteRoute =
  ProspectsProspectIdRecordingsRouteRouteImport.update({
    id: '/recordings',
    path: '/recordings',
    getParentRoute: () => ProspectsProspectIdRouteRoute,
  } as any)
const ProspectsProspectIdDocumentsRouteRoute =
  ProspectsProspectIdDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ProspectsProspectIdRouteRoute,
  } as any)
const SettingsCommunityCommunityIdIndexRoute =
  SettingsCommunityCommunityIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SettingsCommunityCommunityIdRouteRoute,
  } as any)
const ProspectsProspectIdRecordingsIndexRoute =
  ProspectsProspectIdRecordingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProspectsProspectIdRecordingsRouteRoute,
  } as any)
const ProspectsProspectIdDocumentsIndexRoute =
  ProspectsProspectIdDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProspectsProspectIdDocumentsRouteRoute,
  } as any)
const SettingsCommunityCommunityIdUsersRoute =
  SettingsCommunityCommunityIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => SettingsCommunityCommunityIdRouteRoute,
  } as any)
const SettingsCommunityCommunityIdRolesRoute =
  SettingsCommunityCommunityIdRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => SettingsCommunityCommunityIdRouteRoute,
  } as any)
const SettingsCommunityCommunityIdPermissionsRoute =
  SettingsCommunityCommunityIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => SettingsCommunityCommunityIdRouteRoute,
  } as any)
const ProspectsProspectIdDocumentsNewRoute =
  ProspectsProspectIdDocumentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProspectsProspectIdDocumentsRouteRoute,
  } as any)
const ProspectsProspectIdRecordingsRecordingIdRouteRoute =
  ProspectsProspectIdRecordingsRecordingIdRouteRouteImport.update({
    id: '/$recordingId',
    path: '/$recordingId',
    getParentRoute: () => ProspectsProspectIdRecordingsRouteRoute,
  } as any)
const ProspectsProspectIdRecordingsRecordingIdIndexRoute =
  ProspectsProspectIdRecordingsRecordingIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProspectsProspectIdRecordingsRecordingIdRouteRoute,
  } as any)
const ProspectsProspectIdDocumentsDocumentIdIndexRoute =
  ProspectsProspectIdDocumentsDocumentIdIndexRouteImport.update({
    id: '/$documentId/',
    path: '/$documentId/',
    getParentRoute: () => ProspectsProspectIdDocumentsRouteRoute,
  } as any)
const ProspectsProspectIdRecordingsRecordingIdTranscriptRoute =
  ProspectsProspectIdRecordingsRecordingIdTranscriptRouteImport.update({
    id: '/transcript',
    path: '/transcript',
    getParentRoute: () => ProspectsProspectIdRecordingsRecordingIdRouteRoute,
  } as any)
const ProspectsProspectIdRecordingsRecordingIdSummaryRoute =
  ProspectsProspectIdRecordingsRecordingIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => ProspectsProspectIdRecordingsRecordingIdRouteRoute,
  } as any)
const ProspectsProspectIdDocumentsDocumentIdEditRoute =
  ProspectsProspectIdDocumentsDocumentIdEditRouteImport.update({
    id: '/$documentId/edit',
    path: '/$documentId/edit',
    getParentRoute: () => ProspectsProspectIdDocumentsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/prospects': typeof ProspectsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/prospects/$prospectId': typeof ProspectsProspectIdRouteRouteWithChildren
  '/notAuthorized/$': typeof NotAuthorizedSplatRoute
  '/prospects/': typeof ProspectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/prospects/$prospectId/documents': typeof ProspectsProspectIdDocumentsRouteRouteWithChildren
  '/prospects/$prospectId/recordings': typeof ProspectsProspectIdRecordingsRouteRouteWithChildren
  '/settings/community/$communityId': typeof SettingsCommunityCommunityIdRouteRouteWithChildren
  '/prospects/$prospectId/living-story': typeof ProspectsProspectIdLivingStoryRoute
  '/prospects/$prospectId/': typeof ProspectsProspectIdIndexRoute
  '/prospects/$prospectId/recordings/$recordingId': typeof ProspectsProspectIdRecordingsRecordingIdRouteRouteWithChildren
  '/prospects/$prospectId/documents/new': typeof ProspectsProspectIdDocumentsNewRoute
  '/settings/community/$communityId/permissions': typeof SettingsCommunityCommunityIdPermissionsRoute
  '/settings/community/$communityId/roles': typeof SettingsCommunityCommunityIdRolesRoute
  '/settings/community/$communityId/users': typeof SettingsCommunityCommunityIdUsersRoute
  '/prospects/$prospectId/documents/': typeof ProspectsProspectIdDocumentsIndexRoute
  '/prospects/$prospectId/recordings/': typeof ProspectsProspectIdRecordingsIndexRoute
  '/settings/community/$communityId/': typeof SettingsCommunityCommunityIdIndexRoute
  '/prospects/$prospectId/documents/$documentId/edit': typeof ProspectsProspectIdDocumentsDocumentIdEditRoute
  '/prospects/$prospectId/recordings/$recordingId/summary': typeof ProspectsProspectIdRecordingsRecordingIdSummaryRoute
  '/prospects/$prospectId/recordings/$recordingId/transcript': typeof ProspectsProspectIdRecordingsRecordingIdTranscriptRoute
  '/prospects/$prospectId/documents/$documentId': typeof ProspectsProspectIdDocumentsDocumentIdIndexRoute
  '/prospects/$prospectId/recordings/$recordingId/': typeof ProspectsProspectIdRecordingsRecordingIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/notAuthorized/$': typeof NotAuthorizedSplatRoute
  '/prospects': typeof ProspectsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/prospects/$prospectId/living-story': typeof ProspectsProspectIdLivingStoryRoute
  '/prospects/$prospectId': typeof ProspectsProspectIdIndexRoute
  '/prospects/$prospectId/documents/new': typeof ProspectsProspectIdDocumentsNewRoute
  '/settings/community/$communityId/permissions': typeof SettingsCommunityCommunityIdPermissionsRoute
  '/settings/community/$communityId/roles': typeof SettingsCommunityCommunityIdRolesRoute
  '/settings/community/$communityId/users': typeof SettingsCommunityCommunityIdUsersRoute
  '/prospects/$prospectId/documents': typeof ProspectsProspectIdDocumentsIndexRoute
  '/prospects/$prospectId/recordings': typeof ProspectsProspectIdRecordingsIndexRoute
  '/settings/community/$communityId': typeof SettingsCommunityCommunityIdIndexRoute
  '/prospects/$prospectId/documents/$documentId/edit': typeof ProspectsProspectIdDocumentsDocumentIdEditRoute
  '/prospects/$prospectId/recordings/$recordingId/summary': typeof ProspectsProspectIdRecordingsRecordingIdSummaryRoute
  '/prospects/$prospectId/recordings/$recordingId/transcript': typeof ProspectsProspectIdRecordingsRecordingIdTranscriptRoute
  '/prospects/$prospectId/documents/$documentId': typeof ProspectsProspectIdDocumentsDocumentIdIndexRoute
  '/prospects/$prospectId/recordings/$recordingId': typeof ProspectsProspectIdRecordingsRecordingIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/prospects': typeof ProspectsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/prospects/$prospectId': typeof ProspectsProspectIdRouteRouteWithChildren
  '/notAuthorized/$': typeof NotAuthorizedSplatRoute
  '/prospects/': typeof ProspectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/prospects/$prospectId/documents': typeof ProspectsProspectIdDocumentsRouteRouteWithChildren
  '/prospects/$prospectId/recordings': typeof ProspectsProspectIdRecordingsRouteRouteWithChildren
  '/settings/community/$communityId': typeof SettingsCommunityCommunityIdRouteRouteWithChildren
  '/prospects/$prospectId/living-story': typeof ProspectsProspectIdLivingStoryRoute
  '/prospects/$prospectId/': typeof ProspectsProspectIdIndexRoute
  '/prospects/$prospectId/recordings/$recordingId': typeof ProspectsProspectIdRecordingsRecordingIdRouteRouteWithChildren
  '/prospects/$prospectId/documents/new': typeof ProspectsProspectIdDocumentsNewRoute
  '/settings/community/$communityId/permissions': typeof SettingsCommunityCommunityIdPermissionsRoute
  '/settings/community/$communityId/roles': typeof SettingsCommunityCommunityIdRolesRoute
  '/settings/community/$communityId/users': typeof SettingsCommunityCommunityIdUsersRoute
  '/prospects/$prospectId/documents/': typeof ProspectsProspectIdDocumentsIndexRoute
  '/prospects/$prospectId/recordings/': typeof ProspectsProspectIdRecordingsIndexRoute
  '/settings/community/$communityId/': typeof SettingsCommunityCommunityIdIndexRoute
  '/prospects/$prospectId/documents/$documentId/edit': typeof ProspectsProspectIdDocumentsDocumentIdEditRoute
  '/prospects/$prospectId/recordings/$recordingId/summary': typeof ProspectsProspectIdRecordingsRecordingIdSummaryRoute
  '/prospects/$prospectId/recordings/$recordingId/transcript': typeof ProspectsProspectIdRecordingsRecordingIdTranscriptRoute
  '/prospects/$prospectId/documents/$documentId/': typeof ProspectsProspectIdDocumentsDocumentIdIndexRoute
  '/prospects/$prospectId/recordings/$recordingId/': typeof ProspectsProspectIdRecordingsRecordingIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/prospects'
    | '/settings'
    | '/dashboard'
    | '/prospects/$prospectId'
    | '/notAuthorized/$'
    | '/prospects/'
    | '/settings/'
    | '/prospects/$prospectId/documents'
    | '/prospects/$prospectId/recordings'
    | '/settings/community/$communityId'
    | '/prospects/$prospectId/living-story'
    | '/prospects/$prospectId/'
    | '/prospects/$prospectId/recordings/$recordingId'
    | '/prospects/$prospectId/documents/new'
    | '/settings/community/$communityId/permissions'
    | '/settings/community/$communityId/roles'
    | '/settings/community/$communityId/users'
    | '/prospects/$prospectId/documents/'
    | '/prospects/$prospectId/recordings/'
    | '/settings/community/$communityId/'
    | '/prospects/$prospectId/documents/$documentId/edit'
    | '/prospects/$prospectId/recordings/$recordingId/summary'
    | '/prospects/$prospectId/recordings/$recordingId/transcript'
    | '/prospects/$prospectId/documents/$documentId'
    | '/prospects/$prospectId/recordings/$recordingId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/notAuthorized/$'
    | '/prospects'
    | '/settings'
    | '/prospects/$prospectId/living-story'
    | '/prospects/$prospectId'
    | '/prospects/$prospectId/documents/new'
    | '/settings/community/$communityId/permissions'
    | '/settings/community/$communityId/roles'
    | '/settings/community/$communityId/users'
    | '/prospects/$prospectId/documents'
    | '/prospects/$prospectId/recordings'
    | '/settings/community/$communityId'
    | '/prospects/$prospectId/documents/$documentId/edit'
    | '/prospects/$prospectId/recordings/$recordingId/summary'
    | '/prospects/$prospectId/recordings/$recordingId/transcript'
    | '/prospects/$prospectId/documents/$documentId'
    | '/prospects/$prospectId/recordings/$recordingId'
  id:
    | '__root__'
    | '/'
    | '/prospects'
    | '/settings'
    | '/dashboard'
    | '/prospects/$prospectId'
    | '/notAuthorized/$'
    | '/prospects/'
    | '/settings/'
    | '/prospects/$prospectId/documents'
    | '/prospects/$prospectId/recordings'
    | '/settings/community/$communityId'
    | '/prospects/$prospectId/living-story'
    | '/prospects/$prospectId/'
    | '/prospects/$prospectId/recordings/$recordingId'
    | '/prospects/$prospectId/documents/new'
    | '/settings/community/$communityId/permissions'
    | '/settings/community/$communityId/roles'
    | '/settings/community/$communityId/users'
    | '/prospects/$prospectId/documents/'
    | '/prospects/$prospectId/recordings/'
    | '/settings/community/$communityId/'
    | '/prospects/$prospectId/documents/$documentId/edit'
    | '/prospects/$prospectId/recordings/$recordingId/summary'
    | '/prospects/$prospectId/recordings/$recordingId/transcript'
    | '/prospects/$prospectId/documents/$documentId/'
    | '/prospects/$prospectId/recordings/$recordingId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProspectsRouteRoute: typeof ProspectsRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  NotAuthorizedSplatRoute: typeof NotAuthorizedSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prospects': {
      id: '/prospects'
      path: '/prospects'
      fullPath: '/prospects'
      preLoaderRoute: typeof ProspectsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/prospects/': {
      id: '/prospects/'
      path: '/'
      fullPath: '/prospects/'
      preLoaderRoute: typeof ProspectsIndexRouteImport
      parentRoute: typeof ProspectsRouteRoute
    }
    '/notAuthorized/$': {
      id: '/notAuthorized/$'
      path: '/notAuthorized/$'
      fullPath: '/notAuthorized/$'
      preLoaderRoute: typeof NotAuthorizedSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prospects/$prospectId': {
      id: '/prospects/$prospectId'
      path: '/$prospectId'
      fullPath: '/prospects/$prospectId'
      preLoaderRoute: typeof ProspectsProspectIdRouteRouteImport
      parentRoute: typeof ProspectsRouteRoute
    }
    '/prospects/$prospectId/': {
      id: '/prospects/$prospectId/'
      path: '/'
      fullPath: '/prospects/$prospectId/'
      preLoaderRoute: typeof ProspectsProspectIdIndexRouteImport
      parentRoute: typeof ProspectsProspectIdRouteRoute
    }
    '/prospects/$prospectId/living-story': {
      id: '/prospects/$prospectId/living-story'
      path: '/living-story'
      fullPath: '/prospects/$prospectId/living-story'
      preLoaderRoute: typeof ProspectsProspectIdLivingStoryRouteImport
      parentRoute: typeof ProspectsProspectIdRouteRoute
    }
    '/settings/community/$communityId': {
      id: '/settings/community/$communityId'
      path: '/community/$communityId'
      fullPath: '/settings/community/$communityId'
      preLoaderRoute: typeof SettingsCommunityCommunityIdRouteRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/prospects/$prospectId/recordings': {
      id: '/prospects/$prospectId/recordings'
      path: '/recordings'
      fullPath: '/prospects/$prospectId/recordings'
      preLoaderRoute: typeof ProspectsProspectIdRecordingsRouteRouteImport
      parentRoute: typeof ProspectsProspectIdRouteRoute
    }
    '/prospects/$prospectId/documents': {
      id: '/prospects/$prospectId/documents'
      path: '/documents'
      fullPath: '/prospects/$prospectId/documents'
      preLoaderRoute: typeof ProspectsProspectIdDocumentsRouteRouteImport
      parentRoute: typeof ProspectsProspectIdRouteRoute
    }
    '/settings/community/$communityId/': {
      id: '/settings/community/$communityId/'
      path: '/'
      fullPath: '/settings/community/$communityId/'
      preLoaderRoute: typeof SettingsCommunityCommunityIdIndexRouteImport
      parentRoute: typeof SettingsCommunityCommunityIdRouteRoute
    }
    '/prospects/$prospectId/recordings/': {
      id: '/prospects/$prospectId/recordings/'
      path: '/'
      fullPath: '/prospects/$prospectId/recordings/'
      preLoaderRoute: typeof ProspectsProspectIdRecordingsIndexRouteImport
      parentRoute: typeof ProspectsProspectIdRecordingsRouteRoute
    }
    '/prospects/$prospectId/documents/': {
      id: '/prospects/$prospectId/documents/'
      path: '/'
      fullPath: '/prospects/$prospectId/documents/'
      preLoaderRoute: typeof ProspectsProspectIdDocumentsIndexRouteImport
      parentRoute: typeof ProspectsProspectIdDocumentsRouteRoute
    }
    '/settings/community/$communityId/users': {
      id: '/settings/community/$communityId/users'
      path: '/users'
      fullPath: '/settings/community/$communityId/users'
      preLoaderRoute: typeof SettingsCommunityCommunityIdUsersRouteImport
      parentRoute: typeof SettingsCommunityCommunityIdRouteRoute
    }
    '/settings/community/$communityId/roles': {
      id: '/settings/community/$communityId/roles'
      path: '/roles'
      fullPath: '/settings/community/$communityId/roles'
      preLoaderRoute: typeof SettingsCommunityCommunityIdRolesRouteImport
      parentRoute: typeof SettingsCommunityCommunityIdRouteRoute
    }
    '/settings/community/$communityId/permissions': {
      id: '/settings/community/$communityId/permissions'
      path: '/permissions'
      fullPath: '/settings/community/$communityId/permissions'
      preLoaderRoute: typeof SettingsCommunityCommunityIdPermissionsRouteImport
      parentRoute: typeof SettingsCommunityCommunityIdRouteRoute
    }
    '/prospects/$prospectId/documents/new': {
      id: '/prospects/$prospectId/documents/new'
      path: '/new'
      fullPath: '/prospects/$prospectId/documents/new'
      preLoaderRoute: typeof ProspectsProspectIdDocumentsNewRouteImport
      parentRoute: typeof ProspectsProspectIdDocumentsRouteRoute
    }
    '/prospects/$prospectId/recordings/$recordingId': {
      id: '/prospects/$prospectId/recordings/$recordingId'
      path: '/$recordingId'
      fullPath: '/prospects/$prospectId/recordings/$recordingId'
      preLoaderRoute: typeof ProspectsProspectIdRecordingsRecordingIdRouteRouteImport
      parentRoute: typeof ProspectsProspectIdRecordingsRouteRoute
    }
    '/prospects/$prospectId/recordings/$recordingId/': {
      id: '/prospects/$prospectId/recordings/$recordingId/'
      path: '/'
      fullPath: '/prospects/$prospectId/recordings/$recordingId/'
      preLoaderRoute: typeof ProspectsProspectIdRecordingsRecordingIdIndexRouteImport
      parentRoute: typeof ProspectsProspectIdRecordingsRecordingIdRouteRoute
    }
    '/prospects/$prospectId/documents/$documentId/': {
      id: '/prospects/$prospectId/documents/$documentId/'
      path: '/$documentId'
      fullPath: '/prospects/$prospectId/documents/$documentId'
      preLoaderRoute: typeof ProspectsProspectIdDocumentsDocumentIdIndexRouteImport
      parentRoute: typeof ProspectsProspectIdDocumentsRouteRoute
    }
    '/prospects/$prospectId/recordings/$recordingId/transcript': {
      id: '/prospects/$prospectId/recordings/$recordingId/transcript'
      path: '/transcript'
      fullPath: '/prospects/$prospectId/recordings/$recordingId/transcript'
      preLoaderRoute: typeof ProspectsProspectIdRecordingsRecordingIdTranscriptRouteImport
      parentRoute: typeof ProspectsProspectIdRecordingsRecordingIdRouteRoute
    }
    '/prospects/$prospectId/recordings/$recordingId/summary': {
      id: '/prospects/$prospectId/recordings/$recordingId/summary'
      path: '/summary'
      fullPath: '/prospects/$prospectId/recordings/$recordingId/summary'
      preLoaderRoute: typeof ProspectsProspectIdRecordingsRecordingIdSummaryRouteImport
      parentRoute: typeof ProspectsProspectIdRecordingsRecordingIdRouteRoute
    }
    '/prospects/$prospectId/documents/$documentId/edit': {
      id: '/prospects/$prospectId/documents/$documentId/edit'
      path: '/$documentId/edit'
      fullPath: '/prospects/$prospectId/documents/$documentId/edit'
      preLoaderRoute: typeof ProspectsProspectIdDocumentsDocumentIdEditRouteImport
      parentRoute: typeof ProspectsProspectIdDocumentsRouteRoute
    }
  }
}

interface ProspectsProspectIdDocumentsRouteRouteChildren {
  ProspectsProspectIdDocumentsNewRoute: typeof ProspectsProspectIdDocumentsNewRoute
  ProspectsProspectIdDocumentsIndexRoute: typeof ProspectsProspectIdDocumentsIndexRoute
  ProspectsProspectIdDocumentsDocumentIdEditRoute: typeof ProspectsProspectIdDocumentsDocumentIdEditRoute
  ProspectsProspectIdDocumentsDocumentIdIndexRoute: typeof ProspectsProspectIdDocumentsDocumentIdIndexRoute
}

const ProspectsProspectIdDocumentsRouteRouteChildren: ProspectsProspectIdDocumentsRouteRouteChildren =
  {
    ProspectsProspectIdDocumentsNewRoute: ProspectsProspectIdDocumentsNewRoute,
    ProspectsProspectIdDocumentsIndexRoute:
      ProspectsProspectIdDocumentsIndexRoute,
    ProspectsProspectIdDocumentsDocumentIdEditRoute:
      ProspectsProspectIdDocumentsDocumentIdEditRoute,
    ProspectsProspectIdDocumentsDocumentIdIndexRoute:
      ProspectsProspectIdDocumentsDocumentIdIndexRoute,
  }

const ProspectsProspectIdDocumentsRouteRouteWithChildren =
  ProspectsProspectIdDocumentsRouteRoute._addFileChildren(
    ProspectsProspectIdDocumentsRouteRouteChildren,
  )

interface ProspectsProspectIdRecordingsRecordingIdRouteRouteChildren {
  ProspectsProspectIdRecordingsRecordingIdSummaryRoute: typeof ProspectsProspectIdRecordingsRecordingIdSummaryRoute
  ProspectsProspectIdRecordingsRecordingIdTranscriptRoute: typeof ProspectsProspectIdRecordingsRecordingIdTranscriptRoute
  ProspectsProspectIdRecordingsRecordingIdIndexRoute: typeof ProspectsProspectIdRecordingsRecordingIdIndexRoute
}

const ProspectsProspectIdRecordingsRecordingIdRouteRouteChildren: ProspectsProspectIdRecordingsRecordingIdRouteRouteChildren =
  {
    ProspectsProspectIdRecordingsRecordingIdSummaryRoute:
      ProspectsProspectIdRecordingsRecordingIdSummaryRoute,
    ProspectsProspectIdRecordingsRecordingIdTranscriptRoute:
      ProspectsProspectIdRecordingsRecordingIdTranscriptRoute,
    ProspectsProspectIdRecordingsRecordingIdIndexRoute:
      ProspectsProspectIdRecordingsRecordingIdIndexRoute,
  }

const ProspectsProspectIdRecordingsRecordingIdRouteRouteWithChildren =
  ProspectsProspectIdRecordingsRecordingIdRouteRoute._addFileChildren(
    ProspectsProspectIdRecordingsRecordingIdRouteRouteChildren,
  )

interface ProspectsProspectIdRecordingsRouteRouteChildren {
  ProspectsProspectIdRecordingsRecordingIdRouteRoute: typeof ProspectsProspectIdRecordingsRecordingIdRouteRouteWithChildren
  ProspectsProspectIdRecordingsIndexRoute: typeof ProspectsProspectIdRecordingsIndexRoute
}

const ProspectsProspectIdRecordingsRouteRouteChildren: ProspectsProspectIdRecordingsRouteRouteChildren =
  {
    ProspectsProspectIdRecordingsRecordingIdRouteRoute:
      ProspectsProspectIdRecordingsRecordingIdRouteRouteWithChildren,
    ProspectsProspectIdRecordingsIndexRoute:
      ProspectsProspectIdRecordingsIndexRoute,
  }

const ProspectsProspectIdRecordingsRouteRouteWithChildren =
  ProspectsProspectIdRecordingsRouteRoute._addFileChildren(
    ProspectsProspectIdRecordingsRouteRouteChildren,
  )

interface ProspectsProspectIdRouteRouteChildren {
  ProspectsProspectIdDocumentsRouteRoute: typeof ProspectsProspectIdDocumentsRouteRouteWithChildren
  ProspectsProspectIdRecordingsRouteRoute: typeof ProspectsProspectIdRecordingsRouteRouteWithChildren
  ProspectsProspectIdLivingStoryRoute: typeof ProspectsProspectIdLivingStoryRoute
  ProspectsProspectIdIndexRoute: typeof ProspectsProspectIdIndexRoute
}

const ProspectsProspectIdRouteRouteChildren: ProspectsProspectIdRouteRouteChildren =
  {
    ProspectsProspectIdDocumentsRouteRoute:
      ProspectsProspectIdDocumentsRouteRouteWithChildren,
    ProspectsProspectIdRecordingsRouteRoute:
      ProspectsProspectIdRecordingsRouteRouteWithChildren,
    ProspectsProspectIdLivingStoryRoute: ProspectsProspectIdLivingStoryRoute,
    ProspectsProspectIdIndexRoute: ProspectsProspectIdIndexRoute,
  }

const ProspectsProspectIdRouteRouteWithChildren =
  ProspectsProspectIdRouteRoute._addFileChildren(
    ProspectsProspectIdRouteRouteChildren,
  )

interface ProspectsRouteRouteChildren {
  ProspectsProspectIdRouteRoute: typeof ProspectsProspectIdRouteRouteWithChildren
  ProspectsIndexRoute: typeof ProspectsIndexRoute
}

const ProspectsRouteRouteChildren: ProspectsRouteRouteChildren = {
  ProspectsProspectIdRouteRoute: ProspectsProspectIdRouteRouteWithChildren,
  ProspectsIndexRoute: ProspectsIndexRoute,
}

const ProspectsRouteRouteWithChildren = ProspectsRouteRoute._addFileChildren(
  ProspectsRouteRouteChildren,
)

interface SettingsCommunityCommunityIdRouteRouteChildren {
  SettingsCommunityCommunityIdPermissionsRoute: typeof SettingsCommunityCommunityIdPermissionsRoute
  SettingsCommunityCommunityIdRolesRoute: typeof SettingsCommunityCommunityIdRolesRoute
  SettingsCommunityCommunityIdUsersRoute: typeof SettingsCommunityCommunityIdUsersRoute
  SettingsCommunityCommunityIdIndexRoute: typeof SettingsCommunityCommunityIdIndexRoute
}

const SettingsCommunityCommunityIdRouteRouteChildren: SettingsCommunityCommunityIdRouteRouteChildren =
  {
    SettingsCommunityCommunityIdPermissionsRoute:
      SettingsCommunityCommunityIdPermissionsRoute,
    SettingsCommunityCommunityIdRolesRoute:
      SettingsCommunityCommunityIdRolesRoute,
    SettingsCommunityCommunityIdUsersRoute:
      SettingsCommunityCommunityIdUsersRoute,
    SettingsCommunityCommunityIdIndexRoute:
      SettingsCommunityCommunityIdIndexRoute,
  }

const SettingsCommunityCommunityIdRouteRouteWithChildren =
  SettingsCommunityCommunityIdRouteRoute._addFileChildren(
    SettingsCommunityCommunityIdRouteRouteChildren,
  )

interface SettingsRouteRouteChildren {
  SettingsIndexRoute: typeof SettingsIndexRoute
  SettingsCommunityCommunityIdRouteRoute: typeof SettingsCommunityCommunityIdRouteRouteWithChildren
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsCommunityCommunityIdRouteRoute:
    SettingsCommunityCommunityIdRouteRouteWithChildren,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProspectsRouteRoute: ProspectsRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  DashboardRoute: DashboardRoute,
  NotAuthorizedSplatRoute: NotAuthorizedSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
